/**
 * WebSocket Store (Zustand)
 *
 * Tracks WebSocket connection state for UI indicators.
 * Updated by the socket service on lifecycle events.
 */

import { create } from 'zustand';

type ConnectionStatus = 'connected' | 'reconnecting' | 'disconnected';

interface WebSocketStore {
  status: ConnectionStatus;
  reconnectAttempt: number;

  setStatus: (status: ConnectionStatus) => void;
  setReconnectAttempt: (attempt: number) => void;
  reset: () => void;
}

export const useWebSocketStore = create<WebSocketStore>((set) => ({
  status: 'disconnected',
  reconnectAttempt: 0,

  setStatus: (status) => set({ status }),
  setReconnectAttempt: (attempt) => set({ reconnectAttempt: attempt }),
  reset: () => set({ status: 'disconnected', reconnectAttempt: 0 }),
}));
